import { render } from "./DeliveryStatusBar.vue?vue&type=template&id=61a68324&scoped=true"
import script from "./DeliveryStatusBar.vue?vue&type=script&lang=js"
export * from "./DeliveryStatusBar.vue?vue&type=script&lang=js"

import "./DeliveryStatusBar.vue?vue&type=style&index=0&id=61a68324&scoped=true&lang=css"

import exportComponent from "/builds/weborigo-projects/vivien-vance/core-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61a68324"]])

export default __exports__